/**
 * Matcher for IP Geolocation ("location")
 *
 * Ported from [condition.testLocation@910eca63e4f3eed8604542f849364aa67392c725](https://github.com/optimizely/optimizely/blob/910eca63e4f3eed8604542f849364aa67392c725/src/www/js/client/condition.js#L611).
 * @module
 */

exports.fieldsNeeded = ['location'];

/**
 * @private
 * @param {Object} value
 * @param {Location} [value.location]
 * @param {Object} cond
 * @param {string} cond.value Expected value as [COUNTRY]|[REGION]|[CITY]|[CONTINENT]|[DMA]
 * @returns {boolean}
 */
exports.match = function(value:any, cond:any): boolean {
  if (!value.hasOwnProperty('location')) {
    return false;
  }
  var visitorLocation = value.location;

  var loc = cond.value,
      locSplit = loc.split('|'),
      country = (locSplit[0] || '').trim(),
      region = (locSplit[1] || '').trim(),
      city = (locSplit[2] || '').trim(),
      continent = (locSplit[3] || '').trim(),
      dma = ((locSplit.length > 4 && locSplit[4]) || '').trim();

  // BUG-7439 and CJS-9287 temporary fix for updating old Akamai locations
  // to new Cloudflare ones, which are ISO-3166 compliant
  // remove once geotargeting locations updated to CF
  if (country === 'GB') {
    const regionMap: { [key: string]: string } = {
      EN: 'ENG',
      NI: 'NIR',
      SC: 'SCT',
      WA: 'WLS',
    };
    region = regionMap[region] || region;
  }
  // end temporary fix

  switch (locSplit.length) {
    case 1:
      if (visitorLocation.country === country) {
        return true;
      }
      break;
    case 2:
      if (visitorLocation.region === region &&
          visitorLocation.country === country) {
        return true;
      }
      break;
    case 3:
      if (visitorLocation.city === city &&
          (visitorLocation.region === region || region === '') &&
          visitorLocation.country === country) {
        return true;
      }
      break;
    case 4:
      // If "continent" is specified then all other fields are irrelevant
      if (visitorLocation.continent === continent) {
        return true;
      }
      break;
    case 5:
      // If dma is specified then all other fields are irrelevant (same as above)
      if (visitorLocation.dma === dma) {
        return true;
      }
  }
  return false;
};
